export const shouldForwardProp =
  (customProps: ReadonlyArray<string>) =>
  (prop: string): boolean =>
    !customProps.includes(prop);
